<template>
  <el-dialog :visible.sync="visible" title="删除告警设置" width="480px" custom-class="alarm-delete-dialog" @close="handleClose">
    <div class="delete-confirm-content">
      <div class="confirm-icon"><i class="el-icon-warning"></i></div>
      <div class="confirm-text">
        <p>确认删除以下告警设置吗？</p>
        <p class="setting-info">{{ settingInfo }}</p>
        <p class="warning-text">删除后将无法恢复</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="alarm-btn-cancel" @click="visible = false">取消</el-button>
      <el-button class="alarm-btn-confirm" type="danger" :loading="loading" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAlarmSetting } from '@/api/inspection/alarmSettingManageApi'

export default {
  name: 'DeleteAlarmSetting',
  data() {
    return {
      visible: false,
      loading: false,
      alarmSettingId: '',
      settingInfo: ''
    }
  },
  methods: {
    open(row) {
      this.alarmSettingId = row.alarmSettingId
      this.settingInfo = `${row.communityName} - ${row.alarmTypeName}`
      this.visible = true
    },
    handleClose() {
      this.alarmSettingId = ''
      this.settingInfo = ''
    },
    async handleConfirm() {
      this.loading = true
      try {
        await deleteAlarmSetting({ alarmSettingId: this.alarmSettingId })
        this.$message.success('删除成功')
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || '删除失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.delete-confirm-content {
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
}
.confirm-icon {
  font-size: 48px;
  color: #E6A23C;
  margin-right: 20px;
  flex-shrink: 0;
}
.confirm-text {
  flex: 1;
}
.confirm-text p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #303133;
}
.setting-info {
  font-weight: 600;
  color: #0E76FF;
  margin: 12px 0 !important;
}
.warning-text {
  color: #909399;
  font-size: 13px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
}
.alarm-btn-cancel, .alarm-btn-confirm {
  width: 80px;
  height: 38px;
  border-radius: 10px;
}
.alarm-btn-cancel {
  color: #606266;
  border-color: #DCDFE6;
  background: #fff;
}
.alarm-btn-confirm {
  background: #F56C6C;
  border-color: #F56C6C;
}
.alarm-delete-dialog >>> .el-dialog__header {
  height: 66px;
  padding: 0 24px;
  background: #ebf2fa;
  border-bottom: 1px solid #dce6f5;
  line-height: 66px;
}
.alarm-delete-dialog >>> .el-dialog__title {
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
}
.alarm-delete-dialog >>> .el-dialog__body {
  padding: 20px 24px;
}
</style>
